import { Group, Loader, Title } from '@mantine/core';
import './styles.scss';

interface LoadingDataProps {
  text?: string;
  size?: number;
}

const LoadingData: React.FC<LoadingDataProps> = ({ text, size }) => {
  return (
    <Group className="loading-data">
      <Loader size={size} color="#016273" />
      <Title order={2}>{text}</Title>
    </Group>
  );
};

export default LoadingData;
